unit DonationList;
interface

uses
  System.SysUtils,
  System.DateUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Grid.Plugins,
  smx.webcore.types,
  WEBLib.WebCtrls,
  WEBLib.ExtCtrls,
  WebForm.Core,
  WEBLib.Lists,
  XData.Dataset.Utils,
  XData.Web.Client;

type

  TDonationListType = (dltImport, dltDonor, dltClaim);

  TDonations_List = class(TCoreWebForm)
    DonationsData: TXDataWebDataSet;
    DonationsSource: TDataSource;
    DonationsTable: TDBTableControl;
    DonationsCloseButton: TButton;
    Donors: TXDataWebDataSet;
    RefreshTimer: TTimer;
    DonationsDataId: TIntegerField;
    DonationsDataDateAdded: TDateTimeField;
    DonationsDataAddedBy: TIntegerField;
    DonationsDataLastUpdatedBy: TIntegerField;
    DonationsDataLastUpdated: TDateTimeField;
    DonationsDataExternalId: TStringField;
    DonationsDataTransactionDate: TDateField;
    DonationsDataImportId: TIntegerField;
    DonationsDataClaimId: TIntegerField;
    DonationsDataGiftAid: TFloatField;
    DonationsDataAmount: TFloatField;
    DonationsDataClaimStatus: TStringField;
    DonationsDataClaimDate: TDateTimeField;
    DonationsDataTaxYear: TIntegerField;
    DonationsDataErrorText: TStringField;
    DonationsDataCharityTenant: TStringField;
    DonationsDataSourceType: TStringField;
    DonationsDataComment: TStringField;
    DonationsDataSponsored: TBooleanField;
    DonationsDataNonGiftaidableByCustomerRequest: TBooleanField;
    DonationsDataDonorId: TIntegerField;
    DonationsDataDonorPostCode: TStringField;
    DonationsDataDonorName: TStringField;
    DonationsDataOtherDonationKind: TStringField;
    DonationsDataPaymentMethod: TStringField;
    DonationsDataPaymentMethodNote: TStringField;
    DonationsDataDonationKind: TStringField;
    DonationsDataBankingDate: TDateField;
    DonationsDataBankingReference: TStringField;
    DonationsDataBankingReference2: TStringField;
    DonationsDataAnalysisCode1: TStringField;
    DonationsDataAnalysisCode2: TStringField;
    DonationsDataAnalysisCode3: TStringField;
    DonorsDeclarations: TXDataWebDatasetField;
    DonorsId: TIntegerField;
    DonorsDateAdded: TDateTimeField;
    DonorsAddedBy: TIntegerField;
    DonorsLastUpdatedBy: TIntegerField;
    DonorsLastUpdated: TDateTimeField;
    DonorsTitle: TStringField;
    DonorsFirstName: TStringField;
    DonorsMiddleName: TStringField;
    DonorsLastName: TStringField;
    DonorsSuffix: TStringField;
    DonorsAdd1: TStringField;
    DonorsAdd2: TStringField;
    DonorsAdd3: TStringField;
    DonorsCity: TStringField;
    DonorsPostCode: TStringField;
    DonorsEmail: TStringField;
    DonorsMobile: TStringField;
    DonorsTelephone: TStringField;
    DonorsMatchHash: TStringField;
    DonorsContactByPhone: TBooleanField;
    DonorsContactByPost: TBooleanField;
    DonorsContactByText: TBooleanField;
    DonorsContactByEmail: TBooleanField;
    DonorsDOB: TDateField;
    DonorsHearingStatus: TStringField;
    DonorsEmailStatus: TStringField;
    DonorsLatitude: TFloatField;
    DonorsLongitude: TFloatField;
    DonorsExternalId: TStringField;
    DonorsCountryCode: TStringField;
    DonorsVisualStatus: TStringField;
    DonorsMobilityStatus: TStringField;
    DonorsSourceType: TStringField;
    DonorsImportId: TIntegerField;
    DonorsClaimStatus: TStringField;
    DonorsCharityTenant: TStringField;
    DonorsComments: TStringField;
    DonorsDateOfDeath: TDateField;
    DonationsDataAdjustmentID: TIntegerField;
    AddDonationButton: TButton;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    cbPageSize: TComboBox;
    SearchButton: TButton;
    edSearch: TEdit;
    TitleBarLabel: TLabel;
    DonorsFullName: TStringField;
    DonorsOrganisationName: TStringField;
    DonorsDonorKind: TStringField;
    MessageDialog: TMessageDlg;
    RefreshClaimStatusesButton: TButton;
    DonationsDataClaimStatusDisplay: TStringField;
    procedure WebFormCreate(Sender: TObject);
    procedure AddDonationButtonClick(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure CloseThisButtonClick(Sender: TObject);
    procedure DonationsCloseButtonClick(Sender: TObject);
    procedure DonationsDataAfterApplyUpdates(Sender: TDataSet; Info:
      TResolveResults);
    procedure DonationsDataAfterOpen(DataSet: TDataSet);
    procedure DonationsTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure RefreshTimerTimer(Sender: TObject);
    procedure SearchButtonClick(Sender: TObject);
    procedure DonorsCalcFields(DataSet: TDataSet);
    procedure DonationsDataAmountGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure DonationsDataCalcFields(DataSet: TDataSet);
    procedure RefreshClaimStatusesButtonClick(Sender: TObject);
  private
    { Private declarations }
    FGridPlugin: TGridPlugin;
    FId: Integer;
    FListType: TDonationListType;
    FImportId: Integer;
    FSingleDeclarationId: integer;
    FRefreshingClaimStatuses: Boolean;
    FTaxYear: Integer;
    FClaimStatus: string;
    FClaimRef: string;
    FOnClaimChanged: TNotifyEvent;
    FCanUndoAdjustmentCheckedIds: string;
    FCanUndoAdjustmentAllowedIds: string;
    FLocateDonationIdAfterRefresh: Integer;
    //procedure SetImportId(const Value: Integer);
    [async]
    procedure EditRecord(const RecordId: Integer); async;
    [async]
    procedure DeleteRecord(const RecordId: integer); async;
    [async]
    procedure RemoveDonationFromClaim(const RecordId: integer); async;
    [async]
    procedure CreateAdjustment(const RecordId: integer); async;
    [async]
    procedure UndoAdjustment(const RecordId: integer); async;
    [async]
    procedure CheckCanUndoAdjustment(const RecordId: integer); async;
    [async]
    procedure GetDonorData(DonorId: integer); async;
    procedure SetDonorId(const Value: Integer);
    procedure SetImportId(const Value: Integer);
    procedure SetClaimId(const Value: Integer);
    procedure SetDonorColumnVisibility;
    function RemoveUndoAdjustmentToken(const AList, AToken: string): string;
    procedure RefreshDonationsTable;
    procedure RememberCurrentDonationId;
    procedure EnableRefreshTimer(const AnInterval: Integer = 1000);
    procedure SearchData(const Value: string);
    function TitleBarTextWithDonor: string;
    function CanEditDonationRecords: Boolean;
    function CanCreateAdjustmentForCurrentDonation: Boolean;
    [async]
    procedure UpdateSingleDeclarationWithDonationId(ASingleDeclarationId: integer; ANewDonationId: integer); async;
    [async]
    procedure RefreshClaimStatusesForDonor; async;
    const
      zDonationNotFoundMsg = 'The selected donation could not be found. Please refresh the list and try again.';
  public
    { Public declarations }
    procedure AfterCreated; override;
    property DonorId: Integer write SetDonorId;
    property ImportId: Integer write SetImportId;
    property ClaimId: Integer write SetClaimId;
    property TaxYear: Integer write FTaxYear;
    property ClaimStatus: string write FClaimStatus;
    property ClaimRef: string write FClaimRef;
    property OnClaimChanged: TNotifyEvent read FOnClaimChanged write FOnClaimChanged;
  protected procedure LoadDFMValues; override; end;

var
  Donations_List: TDonations_List;

implementation

{$R *.dfm}

uses
  MainDataModule,
  SMX.Web.Layout.Utils,
  DonationDataEdit,
  Essentials.Web.Shared,
  SMX.CRM.Utils,
  SMX.Web.Utils,
  GA.Web.Utils;

procedure TDonations_List.WebFormCreate(Sender: TObject);
begin
  inherited;
  EssentialsManager.FormSetUp(Self);
  FRefreshingClaimStatuses := False;
  FLocateDonationIdAfterRefresh := 0;
end;

procedure TDonations_List.RefreshClaimStatusesButtonClick(Sender: TObject);
begin
  if FRefreshingClaimStatuses then
    Exit;
  RefreshClaimStatusesForDonor;
end;

procedure TDonations_List.AddDonationButtonClick(Sender: TObject);
begin
  if not CanEditDonationRecords then
    Exit;

  EditRecord(0);

end;

procedure TDonations_List.AfterCreated;
const
  filter_field: array[TDonationListType] of string = ('ImportId', 'DonorId', 'ClaimId');
var
  lFilter: string;
  lStartPage: Integer;
begin
  lFilter := filter_field[FListType] + ' eq ' + FId.ToString + ' and ClaimStatus ne ''Deleted''';
  if FListType = dltClaim then
    lFilter := lFilter + ' and ' + TDonationUIUtils.ClaimScopedStatusODataFilter(FClaimStatus);
  if (FListType = dltClaim) and (FTaxYear > 0) then
    lFilter := lFilter + ' and TaxYear eq ' + FTaxYear.ToString;
  SetDonorColumnVisibility;

  if not assigned(FGridPlugIn) then
  begin
    FGridPlugin := TGridPlugin.Create(DonationsTable, DonationsData, lcPaginator, lbPaginationInfo,
      TSortPair.Create(0, sdDesc));
    FGridPlugin.SetPageSize(StrToInt('10'));
  end;
  if FLocateDonationIdAfterRefresh <= 0 then
    RememberCurrentDonationId;
  lStartPage := FGridPlugin.CurrentPageNumber;
  if lStartPage < 1 then
    lStartPage := 1;
  FGridPlugin.SetPreparedFilter(lFilter, lStartPage);

  if FListType in [dltImport, dltClaim] then
  begin
    AddDonationButton.Visible := False;
    RefreshClaimStatusesButton.Visible := False;
  end
  else
  begin
    AddDonationButton.Visible := CanEditDonationRecords;
    RefreshClaimStatusesButton.Visible := True;
    RefreshClaimStatusesButton.Enabled := not FRefreshingClaimStatuses;
    if FRefreshingClaimStatuses then
      RefreshClaimStatusesButton.Caption := 'Refreshing...'
    else
      RefreshClaimStatusesButton.Caption := 'Refresh';
  end;

  if FListType = dltClaim then
    TitleBarLabel.Caption := TDonationUIUtils.ClaimPopupTitleSuffix(FClaimRef, FTaxYear);

end;

procedure TDonations_List.RefreshClaimStatusesForDonor;
begin
  if (FListType <> dltDonor) or (FId <= 0) or FRefreshingClaimStatuses then
    Exit;

  FRefreshingClaimStatuses := True;
  RefreshClaimStatusesButton.Enabled := False;
  RefreshClaimStatusesButton.Caption := 'Refreshing...';
  try
    await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderService.RefreshDonorDonationClaimStatuses', [FId]));
    RememberCurrentDonationId;
    AfterCreated;
  finally
    FRefreshingClaimStatuses := False;
    RefreshClaimStatusesButton.Caption := 'Refresh';
    RefreshClaimStatusesButton.Enabled := True;
  end;
end;

procedure TDonations_List.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TDonations_List.CloseThisButtonClick(Sender: TObject);
begin
  ModalResult := mrOK;
end;

procedure TDonations_List.CreateAdjustment(const RecordId: integer);
const
end_point = 'IGiftAiderService.CreateAdjustmentFromDonation';
var
  lRetval: TXDataClientResponse;
  lResponse: string;
  mr: TModalResult;
begin

  if not DonationsData.Locate('Id', RecordId, []) then
     Exit;

  //check status
  if (DonationsData.FieldByName('ClaimStatus').AsString <> 'Claimed') and
  (DonationsData.FieldByName('ClaimStatus').AsString <> 'Received') then
  begin
    ShowMessage('Cannot create an adjustment for a donation with this status');
    Exit;
  end;

  if not CanCreateAdjustmentForCurrentDonation then
  begin
    ShowMessage('Cannot create an adjustment for a donation more than a year old');
    Exit;
  end;

  mr := await(TModalResult, MessageDialog.ShowDialog('Create an adjustment for this donation?',
    WEBLib.Dialogs.mtConfirmation, [mbYes, mbNo]));
  if mr <> mrYes then
    Exit;

  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(end_point, [RecordId]));
  lResponse := JS.toString(lRetval.ResultAsObject['value']);

  if (lResponse = 'AdjustmentPending') or (lResponse = 'ClaimReversed') then
  begin
    TJSObject(DonationsData.CurrentData)['ClaimStatus'] := lResponse;
    RefreshDonationsTable;
  end
  else
    ShowMessage('Failed to create an Adjustment: ' + lResponse);

end;

procedure TDonations_List.UndoAdjustment(const RecordId: integer);
const
end_point = 'IGiftAiderService.UndoAdjustmentFromDonation';
var
  lRetval: TXDataClientResponse;
  lResponse: string;
  mr: TModalResult;
begin

  if not DonationsData.Locate('Id', RecordId, []) then
     Exit;

  if DonationsData.FieldByName('ClaimStatus').AsString <> 'AdjustmentPending' then
  begin
    ShowMessage('Cannot undo the adjustment for a donation with this status');
    Exit;
  end;

  mr := await(TModalResult, MessageDialog.ShowDialog('Undo the adjustment for this donation?',
    WEBLib.Dialogs.mtConfirmation, [mbYes, mbNo]));
  if mr <> mrYes then
    Exit;

  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(end_point, [RecordId]));
  lResponse := JS.toString(lRetval.ResultAsObject['value']);

  if (lResponse = 'Claimed') or (lResponse = 'Received') then
  begin
    FCanUndoAdjustmentCheckedIds := RemoveUndoAdjustmentToken(
      FCanUndoAdjustmentCheckedIds, Format('{%d}', [RecordId]));
    FCanUndoAdjustmentAllowedIds := RemoveUndoAdjustmentToken(
      FCanUndoAdjustmentAllowedIds, Format('{%d}', [RecordId]));
    TJSObject(DonationsData.CurrentData)['ClaimStatus'] := lResponse;
    RefreshDonationsTable;
  end
  else
    ShowMessage('Failed to undo the Adjustment: ' + lResponse);

end;

procedure TDonations_List.CheckCanUndoAdjustment(const RecordId: integer);
var
  lRetval: TXDataClientResponse;
  lToken: string;
begin
  lToken := Format('{%d}', [RecordId]);
  try
    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync(
        'IGiftAiderService.CanUndoAdjustmentFromDonation', [RecordId]));
    if JS.toBoolean(lRetval.ResultAsObject['value']) then
    begin
      if Pos(lToken, FCanUndoAdjustmentAllowedIds) = 0 then
        FCanUndoAdjustmentAllowedIds := FCanUndoAdjustmentAllowedIds + lToken;
      RefreshDonationsTable;
    end;
  except
    FCanUndoAdjustmentCheckedIds := RemoveUndoAdjustmentToken(
      FCanUndoAdjustmentCheckedIds, lToken);
  end;
end;

procedure TDonations_List.DeleteRecord(const RecordId: integer);
var
  mr: TModalResult;
begin
  mr := await(TModalResult, MessageDialog.ShowDialog('Are you sure you want to delete this donation?',
    WEBLib.Dialogs.mtConfirmation, [mbYes, mbNo]));
  if mr = mrYes then
  begin
    try
      if DonationsData.Locate('Id', RecordId, []) then
      begin
        DonationsData.Edit;
        DonationsData.FieldByName('ClaimStatus').AsString := 'Deleted';
        DonationsData.Post;
      end;
    finally
      DonationsData.ApplyUpdates;
    end;
  end;
end;

procedure TDonations_List.RemoveDonationFromClaim(const RecordId: integer);
var
  mr: TModalResult;
begin
  if FListType <> dltClaim then
    Exit;

  mr := await(TModalResult, MessageDialog.ShowDialog('Remove this donation from the claim?',
    WEBLib.Dialogs.mtConfirmation, [mbYes, mbNo]));
  if mr <> mrYes then
    Exit;

  await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(
    'IGiftAiderService.RemoveDonationFromPreparedClaim', [FId, RecordId]));
  AfterCreated;
  if Assigned(FOnClaimChanged) then
    FOnClaimChanged(Self);
end;

function TDonations_List.TitleBarTextWithDonor: string;
begin
  if Donors.FieldByName('DonorKind').AsString <> 'Individual' then
    Result := Donors.FieldByName('OrganisationName').AsString
  else
    Result := Donors.FieldByName('FirstName').AsString + ' ' + Donors.FieldByName('LastName').AsString;
end;

procedure TDonations_List.DonationsCloseButtonClick(Sender: TObject);
begin
  ModalResult := mrOK;
end;

procedure TDonations_List.DonationsDataAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  lNewDonationId: integer;
  I: Integer;
  lValue: JSValue;
begin
  inherited;
  //EnableRefreshTimer;

  TXDataDSUtils.UpdateAllIds(TXDataWebDataSet(Sender), Info, 'Id', true);
  lNewDonationId := 0;
  if Sender.Active and Assigned(Sender.FindField('Id')) and not Sender.FieldByName('Id').IsNull then
    lNewDonationId := Sender.FieldByName('Id').AsInteger;

  if lNewDonationId <= 0 then
  begin
    for I := 0 to Length(Info.Records) - 1 do
    begin
      if (Info.Records[I].Error <> '') or (Info.Records[I].Status <> TUpdateStatus.usInserted) then
        Continue;
      lValue := TJSObject(Info.Records[I].Data)['Id'];
      if lValue <> nil then
        lNewDonationId := Integer(lValue);
      Break;
    end;
  end;

  if lNewDonationId > 0 then
    FLocateDonationIdAfterRefresh := lNewDonationId;

  AfterCreated;

  if FSingleDeclarationId <> 0 then
  begin
    UpdateSingleDeclarationWithDonationId(FSingleDeclarationId, lNewDonationId);
  end;

  { TODO Add donationid to declaration }
end;

procedure TDonations_List.DonationsDataAfterOpen(DataSet: TDataSet);
var
  lId: Integer;
begin
  lId := FLocateDonationIdAfterRefresh;
  FLocateDonationIdAfterRefresh := 0;
  if (lId > 0) and DataSet.Active then
    DataSet.Locate('Id', lId, []);
end;

procedure TDonations_List.RememberCurrentDonationId;
begin
  if FLocateDonationIdAfterRefresh > 0 then
    Exit;
  if not DonationsData.Active or DonationsData.IsEmpty then
    Exit;
  if DonationsData.FindField('Id') = nil then
    Exit;
  if not DonationsData.FieldByName('Id').IsNull then
    FLocateDonationIdAfterRefresh := DonationsData.FieldByName('Id').AsInteger;
end;

procedure TDonations_List.DonationsDataAmountGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := FormatFloat(SYS_MONEY_FORMAT, (Sender as TFloatField).AsFloat);
end;

procedure TDonations_List.EditRecord(const RecordId: Integer);
var
  AForm: TDonationDataEditForm;
  LCanEditThisRecord: Boolean;
  LDonorId: Integer;
  LKeepDonationId: Integer;
begin
  if (RecordId = 0) and (not CanEditDonationRecords) then
    Exit;

  AForm := TDonationDataEditForm.Create(nil);
  LKeepDonationId := RecordId;
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    await(TForm, AForm.Load());
    LCanEditThisRecord := CanEditDonationRecords;

    if RecordId = 0 then
    begin
      DonationsData.Insert;
      DonationsData.FieldByName('DonorId').AsInteger := FId;
      DonationsData.FieldByName('ImportId').AsInteger := FImportId;

      if Donors.FieldByName('DonorKind').AsString = 'Individual' then
        DonationsData.FieldByName('DonorName').AsString := (Donors.FieldByName('FirstName').AsString + ' ' +
          Donors.FieldByName('LastName').AsString).Trim
      else
        DonationsData.FieldByName('DonorName').AsString := Donors.FieldByName('OrganisationName').AsString;
      DonationsData.FieldByName('DonorPostCode').AsString := Donors.FieldByName('PostCode').AsString;
      DonationsData.FieldByName('SourceType').AsString := 'Manual';

      if Donors.Active and (not Donors.IsEmpty) then
        AForm.SetDonorSnapshot(
          Donors.FieldByName('DonorKind').AsString,
          Donors.FieldByName('ClaimStatus').AsString,
          Donors.FieldByName('Add1').AsString,
          Donors.FieldByName('PostCode').AsString,
          Donors.FieldByName('DateOfDeath').AsDateTime);

      AForm.DataSet := DonationsData;
      AForm.CheckEdit;
    end
    else
    begin
      if DonationsData.Locate('Id', RecordId, []) then
      begin
        LCanEditThisRecord := LCanEditThisRecord and
          not TDonationUIUtils.DonationClaimStatusIsLocked(DonationsData.FieldByName('ClaimStatus').AsString);

        // Import-mode lists are not donor-scoped, so ensure donor data is loaded
        // for the selected donation before reading Donors fields below.
        LDonorId := DonationsData.FieldByName('DonorId').AsInteger;
        if (not Donors.Active) or Donors.IsEmpty or (Donors.FieldByName('Id').AsInteger <> LDonorId) then
          await(GetDonorData(LDonorId));

        if Donors.Active and (not Donors.IsEmpty) then
          AForm.SetDonorSnapshot(
            Donors.FieldByName('DonorKind').AsString,
            Donors.FieldByName('ClaimStatus').AsString,
            Donors.FieldByName('Add1').AsString,
            Donors.FieldByName('PostCode').AsString,
            Donors.FieldByName('DateOfDeath').AsDateTime);

        AForm.AllowEdit := LCanEditThisRecord;
        AForm.DataSet := DonationsData;
        AForm.CheckEdit;
      end
      else
      begin
        ShowMessage(zDonationNotFoundMsg);
        Exit;
      end;
    end;

    if RecordId = 0 then
      AForm.AllowEdit := LCanEditThisRecord;

    AForm.AfterCreated;
    await(TModalResult, AForm.Execute);

    if (not AForm.EditDataApplyUpdates) and DonationsData.Active and (DonationsData.State in dsEditModes) then
      DonationsData.Cancel;

    if AForm.SavedDonationId > 0 then
      LKeepDonationId := AForm.SavedDonationId;

    FLocateDonationIdAfterRefresh := LKeepDonationId;
    AfterCreated;
    RefreshDonationsTable;
    if (LKeepDonationId > 0) and DonationsData.Active then
      DonationsData.Locate('Id', LKeepDonationId, []);
  finally
    if AForm.EditDataApplyUpdates then
    begin
      FSingleDeclarationId := AForm.SingleDeclarationId;
      //DonationsData.ApplyUpdates;
    end;
    AForm.Free;
    AForm := nil;
  end;
end;

procedure TDonations_List.EnableRefreshTimer(const AnInterval: Integer);
begin
  if RefreshTimer.Enabled then
    Exit;
  RefreshTimer.Interval := AnInterval;
  RefreshTimer.Enabled := True;
end;

procedure TDonations_List.DonationsTableGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; AElement:
  TJSHTMLElementRecord);
var
  RecordId: integer;
  lRecordToken: string;
  Span: THTMLSpan;

  procedure DeleteClick(Sender: TObject);
  begin
    DeleteRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

  procedure RemoveFromClaimClick(Sender: TObject);
  begin
    RemoveDonationFromClaim(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

  procedure OpenPopupClick(Sender: TObject);
  begin
    EditRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

  procedure AdjustmentClick(Sender: TObject);
  begin
    CreateAdjustment(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

  procedure UndoAdjustmentClick(Sender: TObject);
  begin
    UndoAdjustment(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

begin
  if ARow = 0 then
    Exit;

  if not (DonationsTable.Columns[ACol].Title = 'Actions') then
  begin
    Exit;
  end;

  RecordId := DonationsData.FieldByName('Id').AsInteger;
  // Store the record id on each action span so click handlers use the rendered row's id,
  // not whatever id the dataset cursor points to at click time.

  Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-eye', 'View');
  TLayoutUtils.SetActionRecordId(Span, RecordId);
  Span.OnClick := @OpenPopupClick;

  // 'Unknown,Unclaimed,Failed,Scheduled,Submitting,Confirmed,Claimed,Received,Cancelled,Invalid,Deleted,TooOld,NonGiftAidable,NGACustomerRequest,AdjustmentPending,ClaimReversed')


  if (FListType = dltClaim) and
    (DonationsData.FieldByName('ClaimStatus').AsString = 'Scheduled') then
  begin
    Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-unlink', 'Remove from claim');
    TLayoutUtils.SetActionRecordId(Span, RecordId);
    Span.OnClick := @RemoveFromClaimClick;
  end
  else if CanEditDonationRecords and
    not TDonationUIUtils.DonationClaimStatusIsLocked(DonationsData.FieldByName('ClaimStatus').AsString) then
  begin
    Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-trash', 'Delete');
    TLayoutUtils.SetActionRecordId(Span, RecordId);
    Span.OnClick := @DeleteClick;
  end;

  if CanEditDonationRecords and CanCreateAdjustmentForCurrentDonation then
  begin
    Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-exchange-alt', 'Create Adjustment');
    TLayoutUtils.SetActionRecordId(Span, RecordId);
    Span.OnClick := @AdjustmentClick;
  end;

  if CanEditDonationRecords and
    (DonationsData.FieldByName('ClaimStatus').AsString = 'AdjustmentPending') then
  begin
    lRecordToken := Format('{%d}', [RecordId]);
    if Pos(lRecordToken, FCanUndoAdjustmentAllowedIds) > 0 then
    begin
      Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-undo', 'Undo Adjustment');
      TLayoutUtils.SetActionRecordId(Span, RecordId);
      Span.OnClick := @UndoAdjustmentClick;
    end
    else if Pos(lRecordToken, FCanUndoAdjustmentCheckedIds) = 0 then
    begin
      FCanUndoAdjustmentCheckedIds := FCanUndoAdjustmentCheckedIds + lRecordToken;
      CheckCanUndoAdjustment(RecordId);
    end;
  end;

end;

procedure TDonations_List.DonorsCalcFields(DataSet: TDataSet);
begin
  DonorsFullName.Value := TCRMUtils.FullName(Donors);
end;

procedure TDonations_List.SetDonorId(const Value: Integer);
begin
  FListType := dltDonor;
  FId := Value;
  GetDonorData(Value);
end;

procedure TDonations_List.SetImportId(const Value: Integer);
begin
  FListType := dltImport;
  FId := Value;
end;

procedure TDonations_List.SetClaimId(const Value: Integer);
begin
  FListType := dltClaim;
  FId := Value;
end;

procedure TDonations_List.SetDonorColumnVisibility;
var
  I: Integer;
begin
  if FListType <> dltDonor then
    Exit;

  for I := DonationsTable.Columns.Count - 1 downto 0 do
  begin
    if (DonationsTable.Columns[I].DataField = 'DonorName') or
      (DonationsTable.Columns[I].DataField = 'DonorPostCode') then
      DonationsTable.Columns.Delete(I);
  end;
end;

function TDonations_List.RemoveUndoAdjustmentToken(const AList, AToken: string): string;
var
  P: Integer;
begin
  Result := AList;
  if AToken = '' then
    Exit;
  P := Pos(AToken, Result);
  if P > 0 then
    Delete(Result, P, Length(AToken));
end;

procedure TDonations_List.RefreshDonationsTable;
begin
  DonationsTable.DataSource := nil;
  DonationsTable.DataSource := DonationsSource;
  DonationsTable.Invalidate;
end;

procedure TDonations_List.GetDonorData(DonorId: integer);
var
  lDonorClaimStatus: string;
begin
  Donors.Close;
  Donors.QueryString := '$filter=Id eq ' + inttostr(DonorId);
  Await(Donors.LoadAsync);
  if (not Donors.Active) or Donors.IsEmpty then
    Exit;
  TitleBarLabel.Caption := TitleBarTextWithDonor;

  lDonorClaimStatus := Donors.FieldByName('ClaimStatus').AsString;
  AddDonationButton.Enabled := CanEditDonationRecords and
  (lDonorClaimStatus <> 'Deceased') and (lDonorClaimStatus <> 'Inactive');
end;

procedure TDonations_List.RefreshTimerTimer(Sender: TObject);
begin
  //  DonationsData.DisableControls;
  //  DonationsData.Close;
  //  DonationsData.Load;
  //  DonationsData.EnableControls;
  AfterCreated;
  RefreshTimer.Enabled := False;
end;

procedure TDonations_List.SearchButtonClick(Sender: TObject);
begin
  SearchData(edSearch.Text);
end;

procedure TDonations_List.SearchData(const Value: string);
begin
  FGridPlugin.SetFilterText(Value, True);
end;

function TDonations_List.CanEditDonationRecords: Boolean;
begin
  // Central permission hook for future role-specific donation editing.
  // This can later read user scope/claims without touching row action wiring.
  Result := True;
end;

function TDonations_List.CanCreateAdjustmentForCurrentDonation: Boolean;
begin
  Result := ((DonationsData.FieldByName('ClaimStatus').AsString = 'Claimed') or
    (DonationsData.FieldByName('ClaimStatus').AsString = 'Received')) and
    (DonationsData.FieldByName('TransactionDate').AsDateTime >= IncYear(Date, -1));
end;

procedure TDonations_List.DonationsDataCalcFields(DataSet: TDataSet);
begin
  DonationsDataClaimStatusDisplay.Value := TUtils.SplitOnCaps(DonationsDataClaimStatus.Value);
end;

procedure TDonations_List.UpdateSingleDeclarationWithDonationId(ASingleDeclarationId: integer; ANewDonationId: integer);
begin
  await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.UpdateSingleDeclarationDonationId',
    [ASingleDeclarationId, ANewDonationId]));

end;

procedure TDonations_List.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('DonationsListPageInfo');
  TitleBarLabel := TLabel.Create('TitleBar');
  DonationsTable := TDBTableControl.Create('DonationsTable');
  DonationsCloseButton := TButton.Create('DonationsCloseButton');
  AddDonationButton := TButton.Create('AddDonationButton');
  RefreshClaimStatusesButton := TButton.Create('RefreshClaimStatusesButton');
  lcPaginator := TListControl.Create('DonationsListPagination');
  cbPageSize := TComboBox.Create('DonationsListPageSizeSelect');
  SearchButton := TButton.Create('DonationsListSearchButton');
  edSearch := TEdit.Create('DonationsListSearchText');
  MessageDialog := TMessageDlg.Create(Self);
  DonationsData := TXDataWebDataSet.Create(Self);
  DonationsDataId := TIntegerField.Create(Self);
  DonationsDataDateAdded := TDateTimeField.Create(Self);
  DonationsDataAddedBy := TIntegerField.Create(Self);
  DonationsDataLastUpdatedBy := TIntegerField.Create(Self);
  DonationsDataLastUpdated := TDateTimeField.Create(Self);
  DonationsDataExternalId := TStringField.Create(Self);
  DonationsDataTransactionDate := TDateField.Create(Self);
  DonationsDataImportId := TIntegerField.Create(Self);
  DonationsDataClaimId := TIntegerField.Create(Self);
  DonationsDataGiftAid := TFloatField.Create(Self);
  DonationsDataAmount := TFloatField.Create(Self);
  DonationsDataClaimStatus := TStringField.Create(Self);
  DonationsDataClaimDate := TDateTimeField.Create(Self);
  DonationsDataTaxYear := TIntegerField.Create(Self);
  DonationsDataErrorText := TStringField.Create(Self);
  DonationsDataCharityTenant := TStringField.Create(Self);
  DonationsDataSourceType := TStringField.Create(Self);
  DonationsDataComment := TStringField.Create(Self);
  DonationsDataSponsored := TBooleanField.Create(Self);
  DonationsDataNonGiftaidableByCustomerRequest := TBooleanField.Create(Self);
  DonationsDataDonorId := TIntegerField.Create(Self);
  DonationsDataDonorPostCode := TStringField.Create(Self);
  DonationsDataDonorName := TStringField.Create(Self);
  DonationsDataAdjustmentID := TIntegerField.Create(Self);
  DonationsDataOtherDonationKind := TStringField.Create(Self);
  DonationsDataDonationKind := TStringField.Create(Self);
  DonationsDataPaymentMethod := TStringField.Create(Self);
  DonationsDataPaymentMethodNote := TStringField.Create(Self);
  DonationsDataBankingDate := TDateField.Create(Self);
  DonationsDataBankingReference := TStringField.Create(Self);
  DonationsDataBankingReference2 := TStringField.Create(Self);
  DonationsDataAnalysisCode1 := TStringField.Create(Self);
  DonationsDataAnalysisCode2 := TStringField.Create(Self);
  DonationsDataAnalysisCode3 := TStringField.Create(Self);
  DonationsDataClaimStatusDisplay := TStringField.Create(Self);
  DonationsSource := TDataSource.Create(Self);
  Donors := TXDataWebDataSet.Create(Self);
  DonorsDeclarations := TXDataWebDatasetField.Create(Self);
  DonorsId := TIntegerField.Create(Self);
  DonorsDateAdded := TDateTimeField.Create(Self);
  DonorsAddedBy := TIntegerField.Create(Self);
  DonorsLastUpdatedBy := TIntegerField.Create(Self);
  DonorsLastUpdated := TDateTimeField.Create(Self);
  DonorsTitle := TStringField.Create(Self);
  DonorsFirstName := TStringField.Create(Self);
  DonorsMiddleName := TStringField.Create(Self);
  DonorsLastName := TStringField.Create(Self);
  DonorsSuffix := TStringField.Create(Self);
  DonorsAdd1 := TStringField.Create(Self);
  DonorsAdd2 := TStringField.Create(Self);
  DonorsAdd3 := TStringField.Create(Self);
  DonorsCity := TStringField.Create(Self);
  DonorsPostCode := TStringField.Create(Self);
  DonorsEmail := TStringField.Create(Self);
  DonorsMobile := TStringField.Create(Self);
  DonorsTelephone := TStringField.Create(Self);
  DonorsMatchHash := TStringField.Create(Self);
  DonorsContactByPhone := TBooleanField.Create(Self);
  DonorsContactByPost := TBooleanField.Create(Self);
  DonorsContactByText := TBooleanField.Create(Self);
  DonorsContactByEmail := TBooleanField.Create(Self);
  DonorsDOB := TDateField.Create(Self);
  DonorsHearingStatus := TStringField.Create(Self);
  DonorsEmailStatus := TStringField.Create(Self);
  DonorsLatitude := TFloatField.Create(Self);
  DonorsLongitude := TFloatField.Create(Self);
  DonorsExternalId := TStringField.Create(Self);
  DonorsCountryCode := TStringField.Create(Self);
  DonorsVisualStatus := TStringField.Create(Self);
  DonorsMobilityStatus := TStringField.Create(Self);
  DonorsSourceType := TStringField.Create(Self);
  DonorsImportId := TIntegerField.Create(Self);
  DonorsClaimStatus := TStringField.Create(Self);
  DonorsCharityTenant := TStringField.Create(Self);
  DonorsComments := TStringField.Create(Self);
  DonorsFullName := TStringField.Create(Self);
  DonorsOrganisationName := TStringField.Create(Self);
  DonorsDonorKind := TStringField.Create(Self);
  DonorsDateOfDeath := TDateField.Create(Self);
  RefreshTimer := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  TitleBarLabel.BeforeLoadDFMValues;
  DonationsTable.BeforeLoadDFMValues;
  DonationsCloseButton.BeforeLoadDFMValues;
  AddDonationButton.BeforeLoadDFMValues;
  RefreshClaimStatusesButton.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  SearchButton.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  MessageDialog.BeforeLoadDFMValues;
  DonationsData.BeforeLoadDFMValues;
  DonationsDataId.BeforeLoadDFMValues;
  DonationsDataDateAdded.BeforeLoadDFMValues;
  DonationsDataAddedBy.BeforeLoadDFMValues;
  DonationsDataLastUpdatedBy.BeforeLoadDFMValues;
  DonationsDataLastUpdated.BeforeLoadDFMValues;
  DonationsDataExternalId.BeforeLoadDFMValues;
  DonationsDataTransactionDate.BeforeLoadDFMValues;
  DonationsDataImportId.BeforeLoadDFMValues;
  DonationsDataClaimId.BeforeLoadDFMValues;
  DonationsDataGiftAid.BeforeLoadDFMValues;
  DonationsDataAmount.BeforeLoadDFMValues;
  DonationsDataClaimStatus.BeforeLoadDFMValues;
  DonationsDataClaimDate.BeforeLoadDFMValues;
  DonationsDataTaxYear.BeforeLoadDFMValues;
  DonationsDataErrorText.BeforeLoadDFMValues;
  DonationsDataCharityTenant.BeforeLoadDFMValues;
  DonationsDataSourceType.BeforeLoadDFMValues;
  DonationsDataComment.BeforeLoadDFMValues;
  DonationsDataSponsored.BeforeLoadDFMValues;
  DonationsDataNonGiftaidableByCustomerRequest.BeforeLoadDFMValues;
  DonationsDataDonorId.BeforeLoadDFMValues;
  DonationsDataDonorPostCode.BeforeLoadDFMValues;
  DonationsDataDonorName.BeforeLoadDFMValues;
  DonationsDataAdjustmentID.BeforeLoadDFMValues;
  DonationsDataOtherDonationKind.BeforeLoadDFMValues;
  DonationsDataDonationKind.BeforeLoadDFMValues;
  DonationsDataPaymentMethod.BeforeLoadDFMValues;
  DonationsDataPaymentMethodNote.BeforeLoadDFMValues;
  DonationsDataBankingDate.BeforeLoadDFMValues;
  DonationsDataBankingReference.BeforeLoadDFMValues;
  DonationsDataBankingReference2.BeforeLoadDFMValues;
  DonationsDataAnalysisCode1.BeforeLoadDFMValues;
  DonationsDataAnalysisCode2.BeforeLoadDFMValues;
  DonationsDataAnalysisCode3.BeforeLoadDFMValues;
  DonationsDataClaimStatusDisplay.BeforeLoadDFMValues;
  DonationsSource.BeforeLoadDFMValues;
  Donors.BeforeLoadDFMValues;
  DonorsDeclarations.BeforeLoadDFMValues;
  DonorsId.BeforeLoadDFMValues;
  DonorsDateAdded.BeforeLoadDFMValues;
  DonorsAddedBy.BeforeLoadDFMValues;
  DonorsLastUpdatedBy.BeforeLoadDFMValues;
  DonorsLastUpdated.BeforeLoadDFMValues;
  DonorsTitle.BeforeLoadDFMValues;
  DonorsFirstName.BeforeLoadDFMValues;
  DonorsMiddleName.BeforeLoadDFMValues;
  DonorsLastName.BeforeLoadDFMValues;
  DonorsSuffix.BeforeLoadDFMValues;
  DonorsAdd1.BeforeLoadDFMValues;
  DonorsAdd2.BeforeLoadDFMValues;
  DonorsAdd3.BeforeLoadDFMValues;
  DonorsCity.BeforeLoadDFMValues;
  DonorsPostCode.BeforeLoadDFMValues;
  DonorsEmail.BeforeLoadDFMValues;
  DonorsMobile.BeforeLoadDFMValues;
  DonorsTelephone.BeforeLoadDFMValues;
  DonorsMatchHash.BeforeLoadDFMValues;
  DonorsContactByPhone.BeforeLoadDFMValues;
  DonorsContactByPost.BeforeLoadDFMValues;
  DonorsContactByText.BeforeLoadDFMValues;
  DonorsContactByEmail.BeforeLoadDFMValues;
  DonorsDOB.BeforeLoadDFMValues;
  DonorsHearingStatus.BeforeLoadDFMValues;
  DonorsEmailStatus.BeforeLoadDFMValues;
  DonorsLatitude.BeforeLoadDFMValues;
  DonorsLongitude.BeforeLoadDFMValues;
  DonorsExternalId.BeforeLoadDFMValues;
  DonorsCountryCode.BeforeLoadDFMValues;
  DonorsVisualStatus.BeforeLoadDFMValues;
  DonorsMobilityStatus.BeforeLoadDFMValues;
  DonorsSourceType.BeforeLoadDFMValues;
  DonorsImportId.BeforeLoadDFMValues;
  DonorsClaimStatus.BeforeLoadDFMValues;
  DonorsCharityTenant.BeforeLoadDFMValues;
  DonorsComments.BeforeLoadDFMValues;
  DonorsFullName.BeforeLoadDFMValues;
  DonorsOrganisationName.BeforeLoadDFMValues;
  DonorsDonorKind.BeforeLoadDFMValues;
  DonorsDateOfDeath.BeforeLoadDFMValues;
  RefreshTimer.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 24;
    lbPaginationInfo.Top := 413;
    lbPaginationInfo.Width := 112;
    lbPaginationInfo.Height := 15;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthStyle := ssAuto;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    TitleBarLabel.SetParentComponent(Self);
    TitleBarLabel.Name := 'TitleBarLabel';
    TitleBarLabel.Left := 347;
    TitleBarLabel.Top := 8;
    TitleBarLabel.Width := 129;
    TitleBarLabel.Height := 15;
    TitleBarLabel.Caption := '                                           ';
    TitleBarLabel.ElementPosition := epIgnore;
    TitleBarLabel.HeightStyle := ssAuto;
    TitleBarLabel.HeightPercent := 100.000000000000000000;
    TitleBarLabel.WidthStyle := ssAuto;
    TitleBarLabel.WidthPercent := 100.000000000000000000;
    DonationsTable.SetParentComponent(Self);
    DonationsTable.Name := 'DonationsTable';
    DonationsTable.Left := 32;
    DonationsTable.Top := 104;
    DonationsTable.Width := 513;
    DonationsTable.Height := 249;
    DonationsTable.HeightStyle := ssAuto;
    DonationsTable.WidthStyle := ssAuto;
    DonationsTable.BorderColor := clSilver;
    DonationsTable.ChildOrder := 4;
    DonationsTable.ElementFont := efCSS;
    DonationsTable.ElementHeaderClassName := 'thead-light';
    DonationsTable.ElementPosition := epIgnore;
    DonationsTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    SetEvent(DonationsTable, Self, 'OnGetCellChildren', 'DonationsTableGetCellChildren');
    DonationsTable.Columns.Clear;
    with DonationsTable.Columns.Add do
    begin
      DataField := 'DonorName';
      Title := 'Donor';
    end;
    with DonationsTable.Columns.Add do
    begin
      DataField := 'DonorPostCode';
      Title := 'Post Code';
    end;
    with DonationsTable.Columns.Add do
    begin
      DataField := 'TransactionDate';
      Title := 'Transaction Date';
    end;
    with DonationsTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'Amount';
      Title := 'Amount';
    end;
    with DonationsTable.Columns.Add do
    begin
      DataField := 'ClaimStatusDisplay';
      Title := 'Status';
    end;
    with DonationsTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    with DonationsTable.Columns.Add do
    begin
      DataField := 'Comment';
      Title := 'Comment';
      Width := 200;
    end;
    DonationsTable.DataSource := DonationsSource;
    DonationsCloseButton.SetParentComponent(Self);
    DonationsCloseButton.Name := 'DonationsCloseButton';
    DonationsCloseButton.Left := 449;
    DonationsCloseButton.Top := 372;
    DonationsCloseButton.Width := 96;
    DonationsCloseButton.Height := 25;
    DonationsCloseButton.Caption := 'Close';
    DonationsCloseButton.ChildOrder := 3;
    DonationsCloseButton.ElementClassName := 'btn btn-light';
    DonationsCloseButton.ElementFont := efCSS;
    DonationsCloseButton.ElementPosition := epIgnore;
    DonationsCloseButton.HeightStyle := ssAuto;
    DonationsCloseButton.HeightPercent := 100.000000000000000000;
    DonationsCloseButton.WidthStyle := ssAuto;
    DonationsCloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(DonationsCloseButton, Self, 'OnClick', 'DonationsCloseButtonClick');
    AddDonationButton.SetParentComponent(Self);
    AddDonationButton.Name := 'AddDonationButton';
    AddDonationButton.Left := 347;
    AddDonationButton.Top := 372;
    AddDonationButton.Width := 96;
    AddDonationButton.Height := 25;
    AddDonationButton.Caption := 'Add';
    AddDonationButton.ChildOrder := 2;
    AddDonationButton.ElementClassName := 'btn btn-secondary';
    AddDonationButton.HeightPercent := 100.000000000000000000;
    AddDonationButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddDonationButton, Self, 'OnClick', 'AddDonationButtonClick');
    RefreshClaimStatusesButton.SetParentComponent(Self);
    RefreshClaimStatusesButton.Name := 'RefreshClaimStatusesButton';
    RefreshClaimStatusesButton.Left := 496;
    RefreshClaimStatusesButton.Top := 19;
    RefreshClaimStatusesButton.Width := 96;
    RefreshClaimStatusesButton.Height := 25;
    RefreshClaimStatusesButton.Hint := 'Recalculate claim status for this donor'#39's donations';
    RefreshClaimStatusesButton.Caption := 'Refresh';
    RefreshClaimStatusesButton.ChildOrder := 2;
    RefreshClaimStatusesButton.ElementClassName := 'btn btn-light';
    RefreshClaimStatusesButton.ElementPosition := epIgnore;
    RefreshClaimStatusesButton.HeightStyle := ssAuto;
    RefreshClaimStatusesButton.HeightPercent := 100.000000000000000000;
    RefreshClaimStatusesButton.ShowHint := True;
    RefreshClaimStatusesButton.Visible := False;
    RefreshClaimStatusesButton.WidthStyle := ssAuto;
    RefreshClaimStatusesButton.WidthPercent := 100.000000000000000000;
    SetEvent(RefreshClaimStatusesButton, Self, 'OnClick', 'RefreshClaimStatusesButtonClick');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 256;
    lcPaginator.Top := 403;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 3;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Items.Clear;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginator.Style := lsPagination;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 32;
    cbPageSize.Top := 75;
    cbPageSize.Width := 81;
    cbPageSize.Height := 23;
    cbPageSize.ElementClassName := 'form-select';
    cbPageSize.ElementFont := efCSS;
    cbPageSize.ElementPosition := epIgnore;
    cbPageSize.HeightStyle := ssAuto;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.Text := '10';
    cbPageSize.WidthStyle := ssAuto;
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    SearchButton.SetParentComponent(Self);
    SearchButton.Name := 'SearchButton';
    SearchButton.Left := 535;
    SearchButton.Top := 65;
    SearchButton.Width := 33;
    SearchButton.Height := 25;
    SearchButton.Caption := 'Find';
    SearchButton.ChildOrder := 7;
    SearchButton.ElementClassName := 'btn btn-primary input-group-append';
    SearchButton.ElementFont := efCSS;
    SearchButton.ElementPosition := epIgnore;
    SearchButton.HeightStyle := ssAuto;
    SearchButton.HeightPercent := 100.000000000000000000;
    SearchButton.Visible := False;
    SearchButton.WidthStyle := ssAuto;
    SearchButton.WidthPercent := 100.000000000000000000;
    SetEvent(SearchButton, Self, 'OnClick', 'SearchButtonClick');
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 66;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.AutoCompletion := acNone;
    edSearch.AutoSelect := False;
    edSearch.ChildOrder := 1;
    edSearch.ElementClassName := 'form-control';
    edSearch.ElementFont := efCSS;
    edSearch.ElementPosition := epIgnore;
    edSearch.HeightStyle := ssAuto;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.Visible := False;
    edSearch.WidthStyle := ssAuto;
    edSearch.WidthPercent := 100.000000000000000000;
    MessageDialog.SetParentComponent(Self);
    MessageDialog.Name := 'MessageDialog';
    MessageDialog.Left := 568;
    MessageDialog.Top := 120;
    MessageDialog.Width := 24;
    MessageDialog.Height := 24;
    MessageDialog.HeightStyle := ssAuto;
    MessageDialog.WidthStyle := ssAuto;
    MessageDialog.Buttons := [];
    MessageDialog.Opacity := 0.200000000000000000;
    DonationsData.SetParentComponent(Self);
    DonationsData.Name := 'DonationsData';
    DonationsData.AfterOpen := DonationsDataAfterOpen;
    DonationsData.AfterApplyUpdates := DonationsDataAfterApplyUpdates;
    SetEvent(DonationsData, Self, 'OnCalcFields', 'DonationsDataCalcFields');
    DonationsData.EntitySetName := 'Donation';
    DonationsData.Connection := MainData.DataConnection;
    DonationsData.Left := 72;
    DonationsData.Top := 8;
    DonationsDataId.SetParentComponent(DonationsData);
    DonationsDataId.Name := 'DonationsDataId';
    DonationsDataId.FieldName := 'Id';
    DonationsDataDateAdded.SetParentComponent(DonationsData);
    DonationsDataDateAdded.Name := 'DonationsDataDateAdded';
    DonationsDataDateAdded.FieldName := 'DateAdded';
    DonationsDataAddedBy.SetParentComponent(DonationsData);
    DonationsDataAddedBy.Name := 'DonationsDataAddedBy';
    DonationsDataAddedBy.FieldName := 'AddedBy';
    DonationsDataLastUpdatedBy.SetParentComponent(DonationsData);
    DonationsDataLastUpdatedBy.Name := 'DonationsDataLastUpdatedBy';
    DonationsDataLastUpdatedBy.FieldName := 'LastUpdatedBy';
    DonationsDataLastUpdated.SetParentComponent(DonationsData);
    DonationsDataLastUpdated.Name := 'DonationsDataLastUpdated';
    DonationsDataLastUpdated.FieldName := 'LastUpdated';
    DonationsDataExternalId.SetParentComponent(DonationsData);
    DonationsDataExternalId.Name := 'DonationsDataExternalId';
    DonationsDataExternalId.FieldName := 'ExternalId';
    DonationsDataExternalId.Size := 64;
    DonationsDataTransactionDate.SetParentComponent(DonationsData);
    DonationsDataTransactionDate.Name := 'DonationsDataTransactionDate';
    DonationsDataTransactionDate.FieldName := 'TransactionDate';
    DonationsDataTransactionDate.DisplayFormat := 'DD/MM/YYYY';
    DonationsDataImportId.SetParentComponent(DonationsData);
    DonationsDataImportId.Name := 'DonationsDataImportId';
    DonationsDataImportId.FieldName := 'ImportId';
    DonationsDataClaimId.SetParentComponent(DonationsData);
    DonationsDataClaimId.Name := 'DonationsDataClaimId';
    DonationsDataClaimId.FieldName := 'ClaimId';
    DonationsDataGiftAid.SetParentComponent(DonationsData);
    DonationsDataGiftAid.Name := 'DonationsDataGiftAid';
    DonationsDataGiftAid.FieldName := 'GiftAid';
    DonationsDataAmount.SetParentComponent(DonationsData);
    DonationsDataAmount.Name := 'DonationsDataAmount';
    DonationsDataAmount.FieldName := 'Amount';
    SetEvent(DonationsDataAmount, Self, 'OnGetText', 'DonationsDataAmountGetText');
    DonationsDataClaimStatus.SetParentComponent(DonationsData);
    DonationsDataClaimStatus.Name := 'DonationsDataClaimStatus';
    DonationsDataClaimStatus.FieldName := 'ClaimStatus';
    DonationsDataClaimStatus.Size := 10;
    DonationsDataClaimDate.SetParentComponent(DonationsData);
    DonationsDataClaimDate.Name := 'DonationsDataClaimDate';
    DonationsDataClaimDate.FieldName := 'ClaimDate';
    DonationsDataTaxYear.SetParentComponent(DonationsData);
    DonationsDataTaxYear.Name := 'DonationsDataTaxYear';
    DonationsDataTaxYear.FieldName := 'TaxYear';
    DonationsDataErrorText.SetParentComponent(DonationsData);
    DonationsDataErrorText.Name := 'DonationsDataErrorText';
    DonationsDataErrorText.FieldName := 'ErrorText';
    DonationsDataErrorText.Size := 1000;
    DonationsDataCharityTenant.SetParentComponent(DonationsData);
    DonationsDataCharityTenant.Name := 'DonationsDataCharityTenant';
    DonationsDataCharityTenant.FieldName := 'CharityTenant';
    DonationsDataSourceType.SetParentComponent(DonationsData);
    DonationsDataSourceType.Name := 'DonationsDataSourceType';
    DonationsDataSourceType.FieldName := 'SourceType';
    DonationsDataSourceType.Size := 9;
    DonationsDataComment.SetParentComponent(DonationsData);
    DonationsDataComment.Name := 'DonationsDataComment';
    DonationsDataComment.FieldName := 'Comment';
    DonationsDataComment.Size := 250;
    DonationsDataSponsored.SetParentComponent(DonationsData);
    DonationsDataSponsored.Name := 'DonationsDataSponsored';
    DonationsDataSponsored.FieldName := 'Sponsored';
    DonationsDataNonGiftaidableByCustomerRequest.SetParentComponent(DonationsData);
    DonationsDataNonGiftaidableByCustomerRequest.Name := 'DonationsDataNonGiftaidableByCustomerRequest';
    DonationsDataNonGiftaidableByCustomerRequest.FieldName := 'NonGiftaidableByCustomerRequest';
    DonationsDataDonorId.SetParentComponent(DonationsData);
    DonationsDataDonorId.Name := 'DonationsDataDonorId';
    DonationsDataDonorId.FieldName := 'DonorId';
    DonationsDataDonorPostCode.SetParentComponent(DonationsData);
    DonationsDataDonorPostCode.Name := 'DonationsDataDonorPostCode';
    DonationsDataDonorPostCode.FieldName := 'DonorPostCode';
    DonationsDataDonorPostCode.Size := 15;
    DonationsDataDonorName.SetParentComponent(DonationsData);
    DonationsDataDonorName.Name := 'DonationsDataDonorName';
    DonationsDataDonorName.FieldName := 'DonorName';
    DonationsDataDonorName.Size := 50;
    DonationsDataAdjustmentID.SetParentComponent(DonationsData);
    DonationsDataAdjustmentID.Name := 'DonationsDataAdjustmentID';
    DonationsDataAdjustmentID.FieldName := 'AdjustmentID';
    DonationsDataOtherDonationKind.SetParentComponent(DonationsData);
    DonationsDataOtherDonationKind.Name := 'DonationsDataOtherDonationKind';
    DonationsDataOtherDonationKind.FieldName := 'OtherDonationKind';
    DonationsDataOtherDonationKind.Size := 100;
    DonationsDataDonationKind.SetParentComponent(DonationsData);
    DonationsDataDonationKind.Name := 'DonationsDataDonationKind';
    DonationsDataDonationKind.FieldName := 'DonationKind';
    DonationsDataDonationKind.Size := 23;
    DonationsDataPaymentMethod.SetParentComponent(DonationsData);
    DonationsDataPaymentMethod.Name := 'DonationsDataPaymentMethod';
    DonationsDataPaymentMethod.FieldName := 'PaymentMethod';
    DonationsDataPaymentMethod.Size := 13;
    DonationsDataPaymentMethodNote.SetParentComponent(DonationsData);
    DonationsDataPaymentMethodNote.Name := 'DonationsDataPaymentMethodNote';
    DonationsDataPaymentMethodNote.FieldName := 'PaymentMethodNote';
    DonationsDataPaymentMethodNote.Size := 75;
    DonationsDataBankingDate.SetParentComponent(DonationsData);
    DonationsDataBankingDate.Name := 'DonationsDataBankingDate';
    DonationsDataBankingDate.FieldName := 'BankingDate';
    DonationsDataBankingReference.SetParentComponent(DonationsData);
    DonationsDataBankingReference.Name := 'DonationsDataBankingReference';
    DonationsDataBankingReference.FieldName := 'BankingReference';
    DonationsDataBankingReference.Size := 25;
    DonationsDataBankingReference2.SetParentComponent(DonationsData);
    DonationsDataBankingReference2.Name := 'DonationsDataBankingReference2';
    DonationsDataBankingReference2.FieldName := 'BankingReference2';
    DonationsDataBankingReference2.Size := 25;
    DonationsDataAnalysisCode1.SetParentComponent(DonationsData);
    DonationsDataAnalysisCode1.Name := 'DonationsDataAnalysisCode1';
    DonationsDataAnalysisCode1.FieldName := 'AnalysisCode1';
    DonationsDataAnalysisCode1.Size := 75;
    DonationsDataAnalysisCode2.SetParentComponent(DonationsData);
    DonationsDataAnalysisCode2.Name := 'DonationsDataAnalysisCode2';
    DonationsDataAnalysisCode2.FieldName := 'AnalysisCode2';
    DonationsDataAnalysisCode2.Size := 75;
    DonationsDataAnalysisCode3.SetParentComponent(DonationsData);
    DonationsDataAnalysisCode3.Name := 'DonationsDataAnalysisCode3';
    DonationsDataAnalysisCode3.FieldName := 'AnalysisCode3';
    DonationsDataAnalysisCode3.Size := 75;
    DonationsDataClaimStatusDisplay.SetParentComponent(DonationsData);
    DonationsDataClaimStatusDisplay.Name := 'DonationsDataClaimStatusDisplay';
    DonationsDataClaimStatusDisplay.FieldKind := fkCalculated;
    DonationsDataClaimStatusDisplay.FieldName := 'ClaimStatusDisplay';
    DonationsDataClaimStatusDisplay.Size := 50;
    DonationsDataClaimStatusDisplay.Calculated := True;
    DonationsSource.SetParentComponent(Self);
    DonationsSource.Name := 'DonationsSource';
    DonationsSource.DataSet := DonationsData;
    DonationsSource.Left := 176;
    DonationsSource.Top := 8;
    Donors.SetParentComponent(Self);
    Donors.Name := 'Donors';
    SetEvent(Donors, Self, 'OnCalcFields', 'DonorsCalcFields');
    Donors.EntitySetName := 'Donor';
    Donors.Connection := MainData.DataConnection;
    Donors.Left := 40;
    Donors.Top := 408;
    DonorsDeclarations.SetParentComponent(Donors);
    DonorsDeclarations.Name := 'DonorsDeclarations';
    DonorsDeclarations.FieldName := 'Declarations';
    DonorsDeclarations.ReadOnly := True;
    DonorsId.SetParentComponent(Donors);
    DonorsId.Name := 'DonorsId';
    DonorsId.FieldName := 'Id';
    DonorsDateAdded.SetParentComponent(Donors);
    DonorsDateAdded.Name := 'DonorsDateAdded';
    DonorsDateAdded.FieldName := 'DateAdded';
    DonorsAddedBy.SetParentComponent(Donors);
    DonorsAddedBy.Name := 'DonorsAddedBy';
    DonorsAddedBy.FieldName := 'AddedBy';
    DonorsLastUpdatedBy.SetParentComponent(Donors);
    DonorsLastUpdatedBy.Name := 'DonorsLastUpdatedBy';
    DonorsLastUpdatedBy.FieldName := 'LastUpdatedBy';
    DonorsLastUpdated.SetParentComponent(Donors);
    DonorsLastUpdated.Name := 'DonorsLastUpdated';
    DonorsLastUpdated.FieldName := 'LastUpdated';
    DonorsTitle.SetParentComponent(Donors);
    DonorsTitle.Name := 'DonorsTitle';
    DonorsTitle.FieldName := 'Title';
    DonorsTitle.Size := 25;
    DonorsFirstName.SetParentComponent(Donors);
    DonorsFirstName.Name := 'DonorsFirstName';
    DonorsFirstName.FieldName := 'FirstName';
    DonorsFirstName.Size := 50;
    DonorsMiddleName.SetParentComponent(Donors);
    DonorsMiddleName.Name := 'DonorsMiddleName';
    DonorsMiddleName.FieldName := 'MiddleName';
    DonorsMiddleName.Size := 50;
    DonorsLastName.SetParentComponent(Donors);
    DonorsLastName.Name := 'DonorsLastName';
    DonorsLastName.FieldName := 'LastName';
    DonorsLastName.Size := 50;
    DonorsSuffix.SetParentComponent(Donors);
    DonorsSuffix.Name := 'DonorsSuffix';
    DonorsSuffix.FieldName := 'Suffix';
    DonorsSuffix.Size := 50;
    DonorsAdd1.SetParentComponent(Donors);
    DonorsAdd1.Name := 'DonorsAdd1';
    DonorsAdd1.FieldName := 'Add1';
    DonorsAdd1.Size := 75;
    DonorsAdd2.SetParentComponent(Donors);
    DonorsAdd2.Name := 'DonorsAdd2';
    DonorsAdd2.FieldName := 'Add2';
    DonorsAdd2.Size := 75;
    DonorsAdd3.SetParentComponent(Donors);
    DonorsAdd3.Name := 'DonorsAdd3';
    DonorsAdd3.FieldName := 'Add3';
    DonorsAdd3.Size := 75;
    DonorsCity.SetParentComponent(Donors);
    DonorsCity.Name := 'DonorsCity';
    DonorsCity.FieldName := 'City';
    DonorsCity.Size := 75;
    DonorsPostCode.SetParentComponent(Donors);
    DonorsPostCode.Name := 'DonorsPostCode';
    DonorsPostCode.FieldName := 'PostCode';
    DonorsPostCode.Size := 15;
    DonorsEmail.SetParentComponent(Donors);
    DonorsEmail.Name := 'DonorsEmail';
    DonorsEmail.FieldName := 'Email';
    DonorsEmail.Size := 75;
    DonorsMobile.SetParentComponent(Donors);
    DonorsMobile.Name := 'DonorsMobile';
    DonorsMobile.FieldName := 'Mobile';
    DonorsMobile.Size := 25;
    DonorsTelephone.SetParentComponent(Donors);
    DonorsTelephone.Name := 'DonorsTelephone';
    DonorsTelephone.FieldName := 'Telephone';
    DonorsTelephone.Size := 25;
    DonorsMatchHash.SetParentComponent(Donors);
    DonorsMatchHash.Name := 'DonorsMatchHash';
    DonorsMatchHash.FieldName := 'MatchHash';
    DonorsMatchHash.Size := 64;
    DonorsContactByPhone.SetParentComponent(Donors);
    DonorsContactByPhone.Name := 'DonorsContactByPhone';
    DonorsContactByPhone.FieldName := 'ContactByPhone';
    DonorsContactByPost.SetParentComponent(Donors);
    DonorsContactByPost.Name := 'DonorsContactByPost';
    DonorsContactByPost.FieldName := 'ContactByPost';
    DonorsContactByText.SetParentComponent(Donors);
    DonorsContactByText.Name := 'DonorsContactByText';
    DonorsContactByText.FieldName := 'ContactByText';
    DonorsContactByEmail.SetParentComponent(Donors);
    DonorsContactByEmail.Name := 'DonorsContactByEmail';
    DonorsContactByEmail.FieldName := 'ContactByEmail';
    DonorsDOB.SetParentComponent(Donors);
    DonorsDOB.Name := 'DonorsDOB';
    DonorsDOB.FieldName := 'DOB';
    DonorsHearingStatus.SetParentComponent(Donors);
    DonorsHearingStatus.Name := 'DonorsHearingStatus';
    DonorsHearingStatus.FieldName := 'HearingStatus';
    DonorsHearingStatus.Size := 8;
    DonorsEmailStatus.SetParentComponent(Donors);
    DonorsEmailStatus.Name := 'DonorsEmailStatus';
    DonorsEmailStatus.FieldName := 'EmailStatus';
    DonorsEmailStatus.Size := 10;
    DonorsLatitude.SetParentComponent(Donors);
    DonorsLatitude.Name := 'DonorsLatitude';
    DonorsLatitude.FieldName := 'Latitude';
    DonorsLongitude.SetParentComponent(Donors);
    DonorsLongitude.Name := 'DonorsLongitude';
    DonorsLongitude.FieldName := 'Longitude';
    DonorsExternalId.SetParentComponent(Donors);
    DonorsExternalId.Name := 'DonorsExternalId';
    DonorsExternalId.FieldName := 'ExternalId';
    DonorsExternalId.Size := 64;
    DonorsCountryCode.SetParentComponent(Donors);
    DonorsCountryCode.Name := 'DonorsCountryCode';
    DonorsCountryCode.FieldName := 'CountryCode';
    DonorsCountryCode.Size := 3;
    DonorsVisualStatus.SetParentComponent(Donors);
    DonorsVisualStatus.Name := 'DonorsVisualStatus';
    DonorsVisualStatus.FieldName := 'VisualStatus';
    DonorsVisualStatus.Size := 8;
    DonorsMobilityStatus.SetParentComponent(Donors);
    DonorsMobilityStatus.Name := 'DonorsMobilityStatus';
    DonorsMobilityStatus.FieldName := 'MobilityStatus';
    DonorsMobilityStatus.Size := 8;
    DonorsSourceType.SetParentComponent(Donors);
    DonorsSourceType.Name := 'DonorsSourceType';
    DonorsSourceType.FieldName := 'SourceType';
    DonorsSourceType.Size := 9;
    DonorsImportId.SetParentComponent(Donors);
    DonorsImportId.Name := 'DonorsImportId';
    DonorsImportId.FieldName := 'ImportId';
    DonorsClaimStatus.SetParentComponent(Donors);
    DonorsClaimStatus.Name := 'DonorsClaimStatus';
    DonorsClaimStatus.FieldName := 'ClaimStatus';
    DonorsClaimStatus.Size := 19;
    DonorsCharityTenant.SetParentComponent(Donors);
    DonorsCharityTenant.Name := 'DonorsCharityTenant';
    DonorsCharityTenant.FieldName := 'CharityTenant';
    DonorsComments.SetParentComponent(Donors);
    DonorsComments.Name := 'DonorsComments';
    DonorsComments.FieldName := 'Comments';
    DonorsComments.Size := 255;
    DonorsFullName.SetParentComponent(Donors);
    DonorsFullName.Name := 'DonorsFullName';
    DonorsFullName.FieldKind := fkCalculated;
    DonorsFullName.FieldName := 'FullName';
    DonorsFullName.Calculated := True;
    DonorsOrganisationName.SetParentComponent(Donors);
    DonorsOrganisationName.Name := 'DonorsOrganisationName';
    DonorsOrganisationName.FieldName := 'OrganisationName';
    DonorsDonorKind.SetParentComponent(Donors);
    DonorsDonorKind.Name := 'DonorsDonorKind';
    DonorsDonorKind.FieldName := 'DonorKind';
    DonorsDateOfDeath.SetParentComponent(Donors);
    DonorsDateOfDeath.Name := 'DonorsDateOfDeath';
    DonorsDateOfDeath.FieldName := 'DateOfDeath';
    RefreshTimer.SetParentComponent(Self);
    RefreshTimer.Name := 'RefreshTimer';
    RefreshTimer.Enabled := False;
    SetEvent(RefreshTimer, Self, 'OnTimer', 'RefreshTimerTimer');
    RefreshTimer.Left := 296;
    RefreshTimer.Top := 8;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    TitleBarLabel.AfterLoadDFMValues;
    DonationsTable.AfterLoadDFMValues;
    DonationsCloseButton.AfterLoadDFMValues;
    AddDonationButton.AfterLoadDFMValues;
    RefreshClaimStatusesButton.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    SearchButton.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    MessageDialog.AfterLoadDFMValues;
    DonationsData.AfterLoadDFMValues;
    DonationsDataId.AfterLoadDFMValues;
    DonationsDataDateAdded.AfterLoadDFMValues;
    DonationsDataAddedBy.AfterLoadDFMValues;
    DonationsDataLastUpdatedBy.AfterLoadDFMValues;
    DonationsDataLastUpdated.AfterLoadDFMValues;
    DonationsDataExternalId.AfterLoadDFMValues;
    DonationsDataTransactionDate.AfterLoadDFMValues;
    DonationsDataImportId.AfterLoadDFMValues;
    DonationsDataClaimId.AfterLoadDFMValues;
    DonationsDataGiftAid.AfterLoadDFMValues;
    DonationsDataAmount.AfterLoadDFMValues;
    DonationsDataClaimStatus.AfterLoadDFMValues;
    DonationsDataClaimDate.AfterLoadDFMValues;
    DonationsDataTaxYear.AfterLoadDFMValues;
    DonationsDataErrorText.AfterLoadDFMValues;
    DonationsDataCharityTenant.AfterLoadDFMValues;
    DonationsDataSourceType.AfterLoadDFMValues;
    DonationsDataComment.AfterLoadDFMValues;
    DonationsDataSponsored.AfterLoadDFMValues;
    DonationsDataNonGiftaidableByCustomerRequest.AfterLoadDFMValues;
    DonationsDataDonorId.AfterLoadDFMValues;
    DonationsDataDonorPostCode.AfterLoadDFMValues;
    DonationsDataDonorName.AfterLoadDFMValues;
    DonationsDataAdjustmentID.AfterLoadDFMValues;
    DonationsDataOtherDonationKind.AfterLoadDFMValues;
    DonationsDataDonationKind.AfterLoadDFMValues;
    DonationsDataPaymentMethod.AfterLoadDFMValues;
    DonationsDataPaymentMethodNote.AfterLoadDFMValues;
    DonationsDataBankingDate.AfterLoadDFMValues;
    DonationsDataBankingReference.AfterLoadDFMValues;
    DonationsDataBankingReference2.AfterLoadDFMValues;
    DonationsDataAnalysisCode1.AfterLoadDFMValues;
    DonationsDataAnalysisCode2.AfterLoadDFMValues;
    DonationsDataAnalysisCode3.AfterLoadDFMValues;
    DonationsDataClaimStatusDisplay.AfterLoadDFMValues;
    DonationsSource.AfterLoadDFMValues;
    Donors.AfterLoadDFMValues;
    DonorsDeclarations.AfterLoadDFMValues;
    DonorsId.AfterLoadDFMValues;
    DonorsDateAdded.AfterLoadDFMValues;
    DonorsAddedBy.AfterLoadDFMValues;
    DonorsLastUpdatedBy.AfterLoadDFMValues;
    DonorsLastUpdated.AfterLoadDFMValues;
    DonorsTitle.AfterLoadDFMValues;
    DonorsFirstName.AfterLoadDFMValues;
    DonorsMiddleName.AfterLoadDFMValues;
    DonorsLastName.AfterLoadDFMValues;
    DonorsSuffix.AfterLoadDFMValues;
    DonorsAdd1.AfterLoadDFMValues;
    DonorsAdd2.AfterLoadDFMValues;
    DonorsAdd3.AfterLoadDFMValues;
    DonorsCity.AfterLoadDFMValues;
    DonorsPostCode.AfterLoadDFMValues;
    DonorsEmail.AfterLoadDFMValues;
    DonorsMobile.AfterLoadDFMValues;
    DonorsTelephone.AfterLoadDFMValues;
    DonorsMatchHash.AfterLoadDFMValues;
    DonorsContactByPhone.AfterLoadDFMValues;
    DonorsContactByPost.AfterLoadDFMValues;
    DonorsContactByText.AfterLoadDFMValues;
    DonorsContactByEmail.AfterLoadDFMValues;
    DonorsDOB.AfterLoadDFMValues;
    DonorsHearingStatus.AfterLoadDFMValues;
    DonorsEmailStatus.AfterLoadDFMValues;
    DonorsLatitude.AfterLoadDFMValues;
    DonorsLongitude.AfterLoadDFMValues;
    DonorsExternalId.AfterLoadDFMValues;
    DonorsCountryCode.AfterLoadDFMValues;
    DonorsVisualStatus.AfterLoadDFMValues;
    DonorsMobilityStatus.AfterLoadDFMValues;
    DonorsSourceType.AfterLoadDFMValues;
    DonorsImportId.AfterLoadDFMValues;
    DonorsClaimStatus.AfterLoadDFMValues;
    DonorsCharityTenant.AfterLoadDFMValues;
    DonorsComments.AfterLoadDFMValues;
    DonorsFullName.AfterLoadDFMValues;
    DonorsOrganisationName.AfterLoadDFMValues;
    DonorsDonorKind.AfterLoadDFMValues;
    DonorsDateOfDeath.AfterLoadDFMValues;
    RefreshTimer.AfterLoadDFMValues;
  end;
end;

end.

